import { render, staticRenderFns } from "./Industry.vue?vue&type=template&id=e3e0a506&scoped=true"
import script from "./Industry.vue?vue&type=script&lang=js"
export * from "./Industry.vue?vue&type=script&lang=js"
import style0 from "./Industry.vue?vue&type=style&index=0&id=e3e0a506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e0a506",
  null
  
)

export default component.exports